'use client'

import React, { useState } from 'react'
import { Box, Button, Link } from '@chakra-ui/react'

type Props = {
  text: string
  url: string
}

const icon = (hovered: boolean): JSX.Element => {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 41 41"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ width: '30px', height: '30px' }}
    >
      <path
        d="M20.4993 37.5832C29.9342 37.5832 37.5827 29.9347 37.5827 20.4998C37.5827 11.065 29.9342 3.4165 20.4993 3.4165C11.0645 3.4165 3.41602 11.065 3.41602 20.4998C3.41602 29.9347 11.0645 37.5832 20.4993 37.5832Z"
        fill={hovered ? 'black' : 'orange'}
        style={{ transition: 'fill 0.3s ease-in-out' }}
      />
      <path
        d="M21 29L28 21.2051L21 13"
        stroke={hovered ? 'orange' : 'white'}
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13 21H28"
        stroke={hovered ? 'orange' : 'white'}
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export const RightArrowButton = ({ text, url }: Props): JSX.Element => {
  const [isHovered, setIsHovered] = useState(false)
  return (
    <Button
      variant="plain"
      as={Link}
      asChild
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <Link
        href={url}
        height="auto"
        _hover={{ textDecoration: 'none' }}
        transition="all 0.3s ease-in-out"
        padding="0"
        target="_blank"
      >
        {text} <Box>{isHovered ? <Box>{icon(isHovered)}</Box> : icon(isHovered)}</Box>
      </Link>
    </Button>
  )
}
